import { BusEvent } from '@web/common';

export class AdminProductCreatedBusEvent extends BusEvent {}
